import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sethtml } from './utils/index'
import './styles/index.scss'

sethtml()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
